import { render, staticRenderFns } from "./DocumentsDetail.vue?vue&type=template&id=4da0e0e7&"
import script from "./DocumentsDetail.vue?vue&type=script&lang=js&"
export * from "./DocumentsDetail.vue?vue&type=script&lang=js&"
import style0 from "./DocumentsDetail.vue?vue&type=style&index=0&id=4da0e0e7&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports